import React from 'react';

export const status = {
  transitionPage: 'fadeIn', // fadeIn, fadeOut
};

const RoutesContext = React.createContext(status);

export default RoutesContext;
